<template>
  <div class="IDcard">
    <div class="cardPic">
      <div class="zhenjian">
        <div class="leftIcon">
          <img src="../assets/images/hukouIcon.png" alt="" />
        </div>
        <div class="word">
          <div class="zhenjianName">居民户口簿</div>
          <div class="pingzhen">电子凭证</div>
        </div>
      </div>
      <div class="dibu" v-show="hasCard" >
       <div class="left" @click="goView"> <!-- <img src="../assets/images/dianziIcon.png" alt="" /> -->
        <div class="word">查看电子证照</div></div>
        <div class="right" @click="handleKookCodeClick">
          <div class="word">查看二维码</div>
          <img
            style="
              height: 14px;
              width: 14px;
              margin-left: 5px;
              vertical-align: middle;
            "
            src="../assets/images/code-icon.png"
            alt=""
          />
        </div>
      </div>
    </div>

    <div class="info" v-show="hasCard">
      <div class="title">证件信息</div>
      <div class="infoList">
        <div class="everyInfo">
          <div class="left">户号:</div>
          <div class="right">{{ firstInfo.HH | filterValue }}</div>
        </div>
        <div class="everyInfo">
          <div class="left">户主姓名:</div>
          <div class="right">{{ firstInfo.HZXM | filterValue }}</div>
        </div>
        <div class="everyInfo">
          <div class="left">地址：</div>
          <div class="right">{{ firstInfo.DZ | filterValue }}</div>
        </div>
        <div class="everyInfo">
          <div class="left">类别：</div>
          <div class="right">{{ firstInfo.PAGE | filterValue }}</div>
        </div>
        <div class="everyInfo">
          <div class="left">户口类型：</div>
          <div class="right">{{ firstInfo.HKLX | filterValue }}</div>
        </div>
        <div class="everyInfo">
          <div class="left">婚姻状况：</div>
          <div class="right">{{ secondInfo.HYZK | filterValue }}</div>
        </div>
        <div class="everyInfo">
          <div class="left">服务处所：</div>
          <div class="right">{{ secondInfo.FWCS | filterValue }}</div>
        </div>
        <div class="everyInfo">
          <div class="left">何时由何地迁来本址：</div>
          <div class="right">{{ secondInfo.HSHDQLBZ | filterValue }}</div>
        </div>
        <div class="everyInfo">
          <div class="left">登记日期：</div>
          <div class="right">{{ secondInfo.DJRQ | filterValue }}</div>
        </div>
        <div class="everyInfo">
          <div class="left">身份证号码：</div>
          <div class="right">{{ secondInfo.SFZ | filterValue }}</div>
        </div>
        <div class="everyInfo">
          <div class="left">何时由何地迁来本市：</div>
          <div class="right">{{ secondInfo.HSHDQLBS | filterValue }}</div>
        </div>
        <div class="everyInfo">
          <div class="left">性别：</div>
          <div class="right">{{ secondInfo.XB | filterValue }}</div>
        </div>
        <div class="everyInfo">
          <div class="left">民族：</div>
          <div class="right">{{ secondInfo.MZ | filterValue }}</div>
        </div>
        <div class="everyInfo">
          <div class="left">出生日期：</div>
          <div class="right">{{ secondInfo.CSRQ | filterValue }}</div>
        </div>
        <div class="everyInfo">
          <div class="left">本市县其他住址：</div>
          <div class="right">{{ secondInfo.BSXQTZZ | filterValue }}</div>
        </div>
        <div class="everyInfo">
          <div class="left">与户主关系：</div>
          <div class="right">{{ secondInfo.YHZGX | filterValue }}</div>
        </div>
        <div class="everyInfo">
          <div class="left">身高：</div>
          <div class="right">
            {{ secondInfo.SG | filterValue }}
            <span v-show="!typeof secondInfo.SG == 'undefined'">cm</span>
          </div>
        </div>
        <div class="everyInfo">
          <div class="left">姓名：</div>
          <div class="right">{{ secondInfo.XM | filterValue }}</div>
        </div>
        <div class="everyInfo">
          <div class="left">出生地：</div>
          <div class="right">{{ secondInfo.CSD | filterValue }}</div>
        </div>
        <div class="everyInfo">
          <div class="left">兵役状况：</div>
          <div class="right">{{ secondInfo.BYZK | filterValue }}</div>
        </div>
        <div class="everyInfo">
          <div class="left">文化程度：</div>
          <div class="right">{{ secondInfo.WHCD | filterValue }}</div>
        </div>
        <div class="everyInfo">
          <div class="left">籍贯：</div>
          <div class="right">{{ secondInfo.JG | filterValue }}</div>
        </div>
      </div>
    </div>
    <div class="shuoming">
      <div class="title">证件说明</div>
      <div class="miaosu">
        <div class="miaosuTitle">证件描述:</div>
        <div class="miaosuWord">
          本证件系与苏州市公安局核发的居民身份证相对应的电子标签，仅限于在苏州市行政区域范围内使用。
        </div>
      </div>
      <div class="fanwei">
        <div class="fanweiTitle">适用范围:</div>
        <div class="fanweiWord">
          1、路面盘查时对证件的检查；<br />
          2、未携带实体身份证时的旅馆入住登记 ；<br />
          3、未携带实体身份证时的网吧登记 。<br />
        </div>
      </div>
      <div class="changjin">更多使用场景正在规划中,敬请期待。</div>
    </div>
    <van-popup v-model="codeShow" class="my-popup">
      <vue-qr
        :size="191"
        :margin="0"
        :auto-color="true"
        :dot-scale="1"
        :text="appSrc"
      />
    </van-popup>
  </div>
</template>

<script>
import { doRem } from "../utils/setrem";
import qs from "qs";
import { Dialog } from "vant";
import VueQr from "vue-qr";

import { Toast } from "vant";
export default {
  mounted() {
    this.chakan();
  },
  filters: {
    filterValue: function (value) {
      if (typeof value == "undefined") {
        return (value = "无");
      } else {
        return value;
      }
    },
  },
  data() {
    return {
      hasCard: false,
      noCard: false,
      data: null,
      base64Src: "",
      base64Arr: [],
      firstInfo: Object,
      secondInfo: Object,
      imgSrc: "",
      appSrc: "",
      codeShow: false,
    };
  },
  components: { VueQr },

  methods: {
    handleKookCodeClick() {
      this.$toast.loading({
        message: "信息获取中...",
        forbidClick: true,
      });
      let params = qs.stringify({ cardType: 8 });
      this.$axios
        .post("/identity/user/otherCert/getQRcode", params)
        .then((res) => {
          console.log(res);
          if (res.data.result !== 1) {
            Toast.clear();
            Dialog.alert({
              message: res.data.reason,
            }).then(() => {});
            return;
          }
          if (res.data.result === 1) {
            Toast.clear();
            this.codeShow = true;
            this.appSrc = res.data.data;
          }
        })
        .catch((err) => {
          Toast.clear();
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => {});
          return;
        });
    },
    getYMDHMS(timestamp) {
      let time = new Date(timestamp);
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let date = time.getDate();
      let hours = time.getHours();
      let minute = time.getMinutes();
      let second = time.getSeconds();

      if (month < 10) {
        month = "0" + month;
      }
      if (date < 10) {
        date = "0" + date;
      }
      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minute < 10) {
        minute = "0" + minute;
      }
      if (second < 10) {
        second = "0" + second;
      }
      return year + "年" + month + "月" + date + "日";
    },

    goView() {
      this.$router.push({
        name: "ZhenjianView2",
        params: {
          imgSrc: this.imgSrc,
        },
      });
    },
    chakan() {
      this.$toast.loading({
        message: "信息获取中...",
        forbidClick: true,
      });
      let params = qs.stringify({
        cardType: 8,
      });
      this.$axios
        .post("identity/user/newCertificate/getCertificate", params)
        .then((res) => {
          console.log(res);
          if (res.data.result !== 1) {
            this.hasCard = false;
            Toast.clear();
            Dialog.alert({
              message: "未查询到相关证件信息",
            }).then(() => {});
            return;
          }
          if (res.data.result === 1) {
            this.hasCard = true;
            res.data.data[1].DJRQ = this.getYMDHMS(res.data.data[1].DJRQ);
            res.data.data[1].CSRQ = this.getYMDHMS(res.data.data[1].CSRQ);
            this.firstInfo = res.data.data[0];
            this.secondInfo = res.data.data[1];
            this.imgSrc = res.data.data[1].DATA_FILE;

            Toast.clear();
          }
        })
        .catch((err) => {
          Toast.clear();
          console.error(err);
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => {});
          return;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.IDcard {
  background-color: #eef4f6;
  padding: 1.5rem 2rem 2rem 2rem;
  min-height: 100vh;
}
.cardPic {
  position: relative;
  background-image: url("../assets/images/hukou.png");
  height: 25rem;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding-top: 4.25rem;
  padding-left: 3.375rem;
  .zhenjian {
    display: flex;
    align-items: center;

    img {
      width: 5.5rem;
    }
    .word {
      margin-left: 1.625rem;
      line-height: 3rem;
      .zhenjianName {
        color: #ffffff;
        font-size: 2rem;
      }
      .pingzhen {
        color: rgba(255, 255, 255, 0.8);
        font-size: 1.625rem;
      }
    }
  }
  .dibu {
    width: 100%;
    background-image: url("../assets/images/dianziBg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 5.5rem;
    .left {
      position: relative;
    }
    .left::after {
      position: absolute;
      right: 0;
      top: 50%;
      margin-top: -7px;
      content: "";
      height: 14px;
      width: 1px;
      background-color: #fff;
    }
    .left,
    .right {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
    }
    div {
      .word {
        margin-left: 1.25rem;
        font-size: 1.875rem;
        color: #ffffff;
      }
      img {
        width: 3.25rem;
        height: 2.375rem;
      }
    }
  }
}
.my-popup {
  padding: 10px;
}
.shuoming {
  margin-top: 1.25rem;
  background-color: #fff;
  padding: 2.5rem 2rem 1.5rem 2rem;
  border-radius: 1rem;
  .title {
    font-size: 2.125rem;
    color: #19212a;
  }
  .miaosu {
    margin-top: 2.125rem;
    color: #555555;
    font-size: 1.6875rem;
    .miaosuWord {
      margin-top: 1.25rem;
    }
  }
  .fanwei {
    color: #555555;
    font-size: 1.6875rem;
    margin-top: 3.75rem;
    .fanweiWord {
      margin-top: 1.25rem;
      line-height: 3.25rem;
    }
  }
  .changjin {
    color: #555555;
    font-size: 1.6875rem;
    margin-top: 1.25rem;
  }
}
.info {
  background-color: #fff;
  margin-top: -1rem;
  padding: 2.5rem 1.875rem 3rem 2.25rem;
  border-radius: 1rem;
  .title {
    color: #19212a;
    font-size: 2.125rem;
    line-height: 3.125rem;
    font-weight: normal;
  }
  .infoList {
    .everyInfo {
      margin-top: 2.25rem;
      display: flex;
      justify-content: space-between;
      .left {
        color: #555555;
        font-size: 1.875rem;
        line-height: 2.75rem;
      }
      .right {
        color: #19212a;
        font-size: 1.875rem;
        line-height: 2.75rem;
        width: 19.5rem;
        text-align: right;
      }
    }
  }
}
</style>